import React from "react";
import { TCaseFilter } from "src/aadeCase/data-access/types";
import { useTranslation } from "react-i18next";
import useGetAvailableLegalTypes from "src/aadeCase/data-access/useGetAvailableLegalTypes";

export default function useGetBasicFilters() {
  const { t } = useTranslation();

  const { data: legalTypeResponse, isLoading: isLoadingLegalTypes } =
    useGetAvailableLegalTypes();

  const filters: TCaseFilter[] = [
    {
      label: t("Δημιουργία υπόθεσης από"),
      component: { type: "datePicker" },
      name: "date_from",
    },
    {
      label: t("Δημιουργία υπόθεσης έως"),
      component: { type: "datePicker" },
      name: "date_to",
    },
    {
      label: t("Αριθμός Υπόθεσης"),
      component: { type: "textField" },
      name: "case_id",
    },
    {
      label: t("Αριθμός Γ.Ε.ΜΗ."),
      component: { type: "textField" },
      name: "argemi",
    },
    {
      label: t("ΑΦΜ"),
      component: { type: "textField" },
      name: "afm",
    },
    {
      label: t("Νομική Μορφή"),
      component: {
        type: "autoComplete",
        options: legalTypeResponse?.data.legalTypes,
        loading: isLoadingLegalTypes,
      },
      name: "legalType",
    },
  ];

  return filters;
}
